import { Component } from '@angular/core';

@Component({
	selector: 'vb-dual-playback-content-container',
	template: ``,
	styleUrls: ['../../player/videogular/VbMediaClick.Directive.ng.less'],
	standalone: false
})
export class VbDualPlaybackContentContainerComponent {}